import type { ModalProps } from '@mantine/core'
import { Modal as MantineModal } from '@mantine/core'

import classes from './Modal.module.css'

export function Modal({
  children,
  classNames,
  onClose,
  opened,
  ...props
}: ModalProps) {
  return (
    <MantineModal
      classNames={{ ...classes, ...classNames }}
      onClose={onClose}
      opened={opened}
      {...props}
    >
      {children}
    </MantineModal>
  )
}
